<template>
  <v-container
    class="text-center align-center px-md-16"
    style="height: 80vh; display: grid"
  >
    <v-card class="bg-card rounded-xl py-5 mt-5">
      <h4 class="text-center text-h4 mb-5">BD Interna</h4>

      <div
        class="d-flex flex-column flex-md-row align-center justify-center mx-md-16"
      >
        <v-btn
          color="secondary"
          class="rounded-lg my-2 my-md-0 elevation-0"
          @click="sync"
          :loading="loading"
        >
          <v-icon>fa-sync</v-icon>
          <span class="text-capitalize ml-2 font-weight-bold"
            >Sincronizar Precios</span
          >
        </v-btn>
      </div>
    </v-card>

    <alerts-cli />
  </v-container>
</template>

<script>
import Swal from 'sweetalert2'
import AlertsCli from '@/components/Alerts.vue'
import Repository from '@/repositories/RepositoryFactory'

const InternalConfigRepository = Repository.get('internalConfiguration')

export default {
  name: 'InternalDb',
  components: {
    AlertsCli,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    sync: async function () {
      this.loading = true
      try {
        const res = await InternalConfigRepository.syncPrices()

        const data = {
          type: 'success',
          title: 'Petición exitosa',
          text: res.data.message,
        }

        this.$store.dispatch('alerts/activeAlerts', data)
      } catch (error) {
        const response = error.response
          ? error.response.data.message ||
            error.response.data.errors?.reduce((acc, cur) => ({
              msg: acc.msg + ', ' + cur.msg,
            })).msg
          : error

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response,
        })
      }
      this.loading = false
    },
  },
}
</script>